import React from 'react';
import { ButtonLoader, ButtonLoaderVariants } from '../../../ButtonLoader/ButtonLoader';

export type RoundedGrayLargeProps = {
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    children?: React.ReactNode;
    disabled?: boolean;
    isLoading?: boolean;
};

export const RoundedGrayLarge: React.FC<RoundedGrayLargeProps> = ({
                                                                      onClick,
                                                                      children,
                                                                      disabled = false,
                                                                      isLoading = false,
                                                                  }) => {
    return (
        <button
            className="disabled:cursor-not-allowed disabled:opacity-[0.4] bg-app-gray-light flex items-center rounded-app-xl px-app-2xl py-app-base font-semibold hover:bg-app-white hover:text-app-background-primary disabled:bg-app-white disabled:text-app-background-primary transition-all"
            onClick={onClick}
            disabled={disabled || isLoading}
        >
            {isLoading ? <ButtonLoader variant={ButtonLoaderVariants.LARGE} /> : null}
            {children}
        </button>
    );
};
